module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page1"
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [(_vm.search.promotionGuid) ? _c('div', {
    staticStyle: {
      "color": "#c82829"
    }
  }, [_vm._v("\n        促销查询结果")]) : _c('div', [_vm._v("查询结果")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar bar-header-secondary"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [_c('a', {
    staticClass: "searchbar-cancel",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "content infinite-scroll-top",
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "id": "products",
      "data-distance": "5"
    }
  }, [(_vm.num === 0 && _vm.allQueryData.length == 0) ? _c('div', [_c('a', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "20px",
      "margin-left": "0.75rem",
      "color": "black"
    }
  }, [_vm._v("没有任何搜索结果!")]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('a', {
    staticStyle: {
      "margin-left": "0.75rem",
      "margin-right": "0.45rem"
    },
    on: {
      "click": _vm.toCust
    }
  }, [_vm._v("去定制!")]) : _c('router-link', {
    staticClass: "item-link item-content",
    staticStyle: {
      "margin-left": "0.75rem",
      "margin-right": "0.45rem"
    },
    attrs: {
      "to": {
        name: 'myMessage'
      }
    }
  }, [_vm._v("请找客服!")])], 1) : _vm._e(), _vm._v(" "), (_vm.num === 1 && _vm.allQueryData.length == 0) ? _c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "20px",
      "margin-left": "0.75rem"
    }
  }, [_vm._v("正在查询中")]), _vm._v(" "), (_vm.showBarForKit) ? _c('div', {
    staticStyle: {
      "color": "#0a8ddf",
      "margin-bottom": "20px",
      "margin-right": "0.75rem"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    attrs: {
      "data-panel": "#panel-right-demo"
    }
  }, [_vm._v("筛选")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.num !== 0 && _vm.allQueryData.length !== 0) ? _c('div', [_c('div', {
    staticClass: "list-block bar-div"
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_vm._v(_vm._s(_vm.total))]), _vm._v("条结果")]), _vm._v(" "), (_vm.showBarForKit) ? _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    attrs: {
      "data-panel": "#panel-right-demo"
    }
  }, [_vm._v("筛选")])]) : _vm._e()])])])]), _vm._v(" "), _c('merchdata', {
    attrs: {
      "merchList": _vm.allQueryData,
      "showBarForKit": _vm.showBarForKit,
      "isFromSearch": true
    }
  }), _vm._v(" "), (_vm.allQueryData.length < _vm.total) ? _c('div', {
    staticClass: "button",
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), (_vm.allQueryData.length <= _vm.total && _vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.onBehalfOfCustomer === 1) ? _c('div', {
    staticClass: "button",
    staticStyle: {
      "text-align": "center",
      "background-color": "white",
      "padding-bottom": "2rem"
    },
    on: {
      "click": _vm.toCust
    }
  }, [_vm._v("我要定制")]) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGoods"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "searchGoods",
      "placeholder": "查询基因/病毒/功能...",
      "data-popup": ".popup-goods",
      "readonly": "",
      "unselectable": "on"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-add23eac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/SearchDetails.vue
// module id = 1707
// module chunks = 8